import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { syncAuditVisit } from '~/utils/auditCorrelation';

// Abre visita nova quando a tela de menu muda, mesmo que a nova tela nao faca
// request (A -> B -> A conta dois acessos a A).
const useAuditCorrelation = (): void => {
  const { pathname } = useLocation();

  useEffect(() => {
    syncAuditVisit(pathname);
  }, [pathname]);
};

export default useAuditCorrelation;
